import { CommonModule } from '@angular/common';
import { ComponentsModule } from 'src/app/components/components.module';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { TextMaskModule } from 'angular2-text-mask';
import { VehicleConfirmationPage } from './vehicle-confirmation.page';
import { VehicleConfirmationPageRoutingModule } from './vehicle-confirmation-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    VehicleConfirmationPageRoutingModule,
    ComponentsModule,
    TextMaskModule,
  ],
  declarations: [VehicleConfirmationPage],
})
export class VehicleConfirmationPageModule {}
